
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ClientFormData } from "@/types/client";

interface BasicInfoSectionProps {
  formData: ClientFormData;
  onFormDataChange: (newData: Partial<ClientFormData>) => void;
}

export const BasicInfoSection = ({ formData, onFormDataChange }: BasicInfoSectionProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-2">
        <Label htmlFor="clientName">Client Name</Label>
        <Input
          id="clientName"
          value={formData.clientName}
          onChange={(e) => onFormDataChange({ clientName: e.target.value })}
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="industry">Industry</Label>
        <Input
          id="industry"
          value={formData.industry}
          onChange={(e) => onFormDataChange({ industry: e.target.value })}
          required
        />
      </div>
    </div>
  );
};
